import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import * as DataPattern from '../constants/DataPattern';

dayjs.extend(customParseFormat)


// return false if empty string....
// check existing logic when replacing this function with the next
// export function isValidStringDate(stringDate) {
//     const date = stringDate ? new Date(stringDate) : null;
//     ////console.log('Date: ' + stringDate);
//     // console.log(stringDate instanceof dayjs);
//     // console.log(typeof stringDate);
//     // console.log(Object.prototype.toString.call(stringDate));
//     ////console.log(date);
//     return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
// }

// Returns true if not empty string and valid format
export function isValidStringDateFmt(stringDate) {
    return stringDate && 
            dayjs(stringDate, 
                [DataPattern.DATE_FORMAT_RO, DataPattern.DATE_TIME_FORMAT_ISO, DataPattern.DATE_TIME_FORMAT_ISO_SHORT], 
                true
            ).isValid();
}

// Returns true if not empty string and valid format
export function isRoLocaleStringDate(stringDate) {
    return stringDate && 
            dayjs(stringDate, 
                DataPattern.DATE_FORMAT_RO, 
                true
            ).isValid();
}

export function getDateFromString(stringDate) {
    return dayjs(stringDate, 
                [DataPattern.DATE_FORMAT_RO, DataPattern.DATE_TIME_FORMAT_ISO, DataPattern.DATE_TIME_FORMAT_ISO_SHORT], 
                true
            );
}


// UTC ends with a Z
// YYYY-MM-DDTHH:MN:SS.MSSZ
// 2023-07-17T11:39:39.386Z
// function isIsoDate(str) {
//     if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
//     const d = new Date(str); 
//     return d instanceof Date && !isNaN(d.getTime()) && d.toISOString()===str; // valid date 
//   }